import mapToAlphanumeric from "../helpers/mapToAlphanumeric";

/**
 * Formats step-by-step a `string` value into an alphanumeric CNPJ.
 * Supports both numeric and alphanumeric CNPJs in the format AA.AAA.AAA/AAAA-99.
 * @example ```js
 * formatToCNPJAlphanumeric('AB12CD34EF5602')
 * //=> 'AB.12C.D34/EF56-02'
 *
 * formatToCNPJAlphanumeric('AB.12C.D34/EF56-02')
 * //=> 'AB.12C.D34/EF56-02'
 *
 * formatToCNPJAlphanumeric('32284981000138')
 * //=> '32.284.981/0001-38'
 *
 * formatToCNPJAlphanumeric('XY987')
 * //=> 'XY.987'
 * ```
 * @param value - A `string` value of an alphanumeric CNPJ.
 */
const formatToCNPJAlphanumeric = (value: string): string =>
  mapToAlphanumeric(value)
    .toUpperCase()
    .replace(/^(.{2})(.+)/, "$1.$2")
    .replace(/^(.{2}\.)(.{3})(.+)/, "$1$2.$3")
    .replace(/^(.{2}\..{3}\.)(.{3})(.+)/, "$1$2/$3")
    .replace(/^(.{2}\..{3}\..{3}\/)(.{4})(.{1,2})$/, "$1$2-$3");

export default formatToCNPJAlphanumeric;
